import { DiscoveryProductsRecentlyAddedResponseType } from "@sellar-io/api-v2/types";

import { twMerge } from "tailwind-merge";
import { DietaryDisplayList } from "../../../../../components/dietaryDisplayList/DietaryDisplayList";
import { ParentLink } from "../../../../../components/navigation/ParentLink";

import { CardImage } from "@sellar-io/components";

import { ImageSlider } from "../../../../../components/imageSlider/ImageSlider";
import { useMediaQuery } from "usehooks-ts";
import { ORDER_BUYER } from "../../../../../constants/routes";

export const SpotlightProductCard = ({
  product,
  className,
  onClick,
}: {
  product: DiscoveryProductsRecentlyAddedResponseType[number];
  className?: string;
  onClick: () => void;
}) => {
  let productHeroImages = product.ProductImages.filter(
    (ProductImage) => !!ProductImage.url,
  ).map((ProductImage) => ProductImage.url);

  if (productHeroImages.length === 0 && product.heroImageUrl)
    productHeroImages = [product.heroImageUrl];

  const hasProductHeroImages =
    productHeroImages && productHeroImages.length > 0;

  const isDesktop = useMediaQuery("(min-width: 770px)");

  return (
    <div
      className={
        "flex min-w-[200px] flex-col gap-4 overflow-hidden rounded-lg shadow-lg"
      }
    >
      <div
        key={product.id}
        className={twMerge("flex h-full cursor-pointer flex-col", className)}
        onClick={onClick}
      >
        <div className="relative h-40 min-w-[200px] cursor-pointer overflow-clip bg-white">
          {hasProductHeroImages ? (
            <ImageSlider
              images={productHeroImages}
              hoverAnimate={true}
              imageClassName="pt-40"
              swipe={isDesktop}
            />
          ) : (
            <div className="relative h-40 min-w-[200px] cursor-pointer overflow-clip rounded-lg bg-white">
              <CardImage
                imageUrl={product.imageUrl ?? product.Supplier?.imageUrl ?? ""}
                fallback="product-hero"
                className={"h-40 w-[250px] blur-lg"}
              />
              <div
                className={
                  "absolute inset-0 flex items-center justify-center text-white"
                }
              >
                <img
                  src={
                    product.imageUrl ??
                    product.Supplier?.Business?.logoUrl ??
                    ""
                  }
                  alt={product.Supplier?.Business?.name}
                  height="100"
                  width="100"
                  className="rounded-full"
                />
              </div>
            </div>
          )}
          <div className="absolute top-2 right-2 left-2 flex">
            <ParentLink
              to={ORDER_BUYER.href({
                supplierIdOrUrlId: product.Supplier?.urlId ?? "undefined",
              })}
              className="flex inline-flex h-[32px] flex-row items-center justify-start gap-1 rounded-[100px] border border-zinc-300 bg-white p-1 pr-2"
            >
              <img
                src={product.Supplier?.Business?.logoUrl ?? ""}
                alt={product.Supplier?.Business?.name}
                height="20"
                width="20"
                className="shrink-0 rounded-full object-cover"
              />
              <p
                className={
                  "overflow-hidden text-sm font-semibold text-nowrap text-ellipsis text-zinc-800"
                }
              >
                {product.Supplier?.Business?.name}
              </p>
            </ParentLink>
          </div>
        </div>
        <div className="mt-2 flex grow flex-col justify-between">
          <div className="px-2 pb-1">
            <p className={"text-sm font-semibold text-zinc-800"}>
              {product.name}{" "}
              <DietaryDisplayList
                dietaryRequirements={{
                  VG: Boolean(product.vegan),
                  GF: Boolean(product.glutenFree),
                  LF: Boolean(product.lactoseFree),
                }}
                mode="text"
              />
            </p>
            <p className={"text-xs text-zinc-500"}>
              {[product.kind, `${product.abv}%`].join(" // ")}
            </p>
          </div>
          <p className="mt-2 border-t border-[#D4D4D8] bg-zinc-50 px-2 py-1.5 text-xs font-bold text-zinc-500">
            &nbsp;
            {product.containerTypes
              .map((type) => type.toUpperCase())
              .join(" • ")}
          </p>
        </div>
      </div>
    </div>
  );
};
